export default {
  A: "A",
  B: "B"
};
